import React, { Component } from 'react';
import LandingPanel from '../../landingPagePanel/landingPagePanel';
import LandingSidebar from '../../landingSidebar/landingSidebar';

const sparkSidebarLinks = [
    {label: 'Overview', to: '/distributed-computing/apache-spark'},
];

class SparkLanding extends Component{

    constructor(props){
        super(props);
        this.SparkConcepts = [
            {id: 1, title: 'What is Apache Spark?',
                content: 'An introduction to Apache Spark and what it can do.',
                slug:'what-is-apache-spark',
                image: "/images/distributed/spark-landing/what-is-apache-spark.svg",
                enabled: false},
            {id: 2, title: 'Concepts in Apache Spark',
                content: 'The concepts behind Apache Spark',
                slug:'apache-spark-concepts',
                image: "/images/distributed/distributed-framework-landing/concepts.svg",
                enabled: false},
            {id: 3, title: 'State in Apache Spark',
                content: 'How Apache Spark handles state',
                slug:'apache-spark-state',
                image: "/images/distributed/distributed-framework-landing/state.svg",
                enabled: false},
            {id: 4, title: 'Persistence in Apache Spark',
                content: 'How Apache Spark handles persistence',
                slug: 'apache-spark-persistence',
                image: '/images/distributed/distributed-framework-landing/persistence.svg',
                enabled: false}

        ];

        this.SparkSimpleExamples = [
            {id: 1, title: 'Word Count',
                content: 'The classic Spark example: counting word occurrences across a text corpus',
                slug:'spark-word-count',
                image: '/images/distributed/spark-landing/word-count.svg',
                enabled: false},
            {id: 2, title: 'Log File Analysis',
                content: 'Parsing and filtering raw server logs with Spark DataFrames',
                slug:'spark-log-file-analysis',
                image: '/images/distributed/spark-landing/log-file-analysis.svg',
                enabled: false},
            {id: 3, title: 'CSV to Parquet',
                content: 'A batch pipeline that converts CSV files into columnar Parquet storage',
                slug:'spark-csv-to-parquet',
                image: '/images/distributed/spark-landing/csv-to-parquet.svg',
                enabled: false},
            {id: 4, title: 'Structured Streaming from Kafka',
                content: 'Ingesting and transforming a live Kafka topic with Spark Structured Streaming',
                slug: 'spark-kafka-streaming',
                image: '/images/distributed/spark-landing/kafka-streaming.svg',
                enabled: false},

        ];

        this.tutorials = [
            {id: 1, title: 'Clickstream Analytics',
                content: 'Windowing and aggregating user click events for a real-time dashboard',
                slug:'spark-clickstream-analytics',
                image: '/images/distributed/spark-landing/clickstream-analytics.svg',
                enabled: false},
            {id: 2, title: 'Fraud Detection Pipeline',
                content: 'Joining transaction streams to flag suspicious activity in real time',
                slug:'spark-fraud-detection',
                image: '/images/distributed/spark-landing/fraud-detection.svg',
                enabled: false}

        ];

        this.regressionBasics = [
            {id: 1, title: 'What is a regression problem',
                content: 'Installing ML.NET and VSCode interactive',
                slug:'basic-regression',
                image: '/images/spark/panel-default-image.svg'},
            {id: 2, title: 'Hello Regression',
                content: 'Training a simple ML.NET Regression model',
                slug:'basic-regression-problem',
                image: '/images/spark/panel-regression.svg'},
            {id: 3, title: 'What is a regression problem',
                content: 'Installing ML.NET and VSCode interactive',
                slug:'basic-regression',
                image: '/images/spark/panel-default-image.svg'},
            {id: 4, title: 'Hello Regression',
                content: 'Training a simple ML.NET Regression model',
                slug:'basic-regression-problem',
                image: '/images/spark/panel-regression.svg'},

        ];
    }

    render(){

        return (
            <React.Fragment>
                <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full">
                    <LandingSidebar title="Apache Spark" links={sparkSidebarLinks}/>
                    <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10 pb-24">
                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-red-400 text-2xl" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor" />
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor" />
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor" />
                                </svg>
                                <div className="h-2" />
                                <div className="flex  rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Spark Concepts
                                        </h2></div>
                                </div>
                                <div className="h-6" />
                                <p className="leading-snug text-gray-500">Some of the concepts underpinning Apache Spark
                                </p>
                                <div className="h-6" />
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.SparkConcepts.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-spark/concepts/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-blue-400 text-2xl" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor"></path>
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor"></path>
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor"></path>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex  rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Simple Examples
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">Some simple examples with Apache Spark
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.SparkSimpleExamples.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-spark/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                        <div className="lg:pr-12 lg:place-self-top">
                            <div className="flex flex-col ">
                                <svg className="text-green-400 text-2xl" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor"></path>
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor"></path>
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor"></path>
                                </svg>
                                <div className="h-2"></div>
                                <div className="flex  rounded-lg">
                                    <div>
                                        <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Advanced Examples
                                        </h2></div>
                                </div>
                                <div className="h-6"></div>
                                <p className="leading-snug text-gray-500">Some more in depth examples
                                </p>
                                <div className="h-6"></div>
                            </div>
                        </div>
                        <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                            {this.tutorials.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-spark/tutorials/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>
                    </section>
                </div>
            </React.Fragment>
        )
    };

}

export default SparkLanding;